import React from 'react'
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import HeadquarterListContainer from '../../containers/goalsetting/HeadquarterListContainer';


const GoalSettingMngPage = () => {
    return (
        <div>
            <BreadcrumbsContainer title="목표 관리/목표 등록/사원별 목표 설정" icon="goal" />

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', }}>
                <Box sx={{ width: "240px", mr: 1 }}>
                    <HeadquarterListContainer />
                </Box>
                <Box sx={{ flexGrow: 1 }}><Outlet /></Box>
            </Box>
        </div>
    )
}

export default GoalSettingMngPage